import { ImportFieldMapState, resolveCollectionCode } from './import-column-mapper';

export type ImportRowScanResult = {
  /** Γραμμές που θα διαβαστούν (συμπεριλαμβανομένων κενών προς skip) */
  totalRows: number;
  /** Πρώτη γραμμή δεδομένων (μετά την επικεφαλίδα) */
  startRow: number;
  /** Τελευταία γραμμή προς επεξεργασία (inclusive) */
  endRowInclusive: number;
};

/** Διαβάζει τιμές κελιών μιας γραμμής από το worksheet */
export function getWorksheetRowValues(sheet: any, rowIndex: number): unknown[] | null {
  const cells = sheet._rows[rowIndex]?._cells;
  if (!cells) return null;
  return cells.map((cell) => cell?._value?.value);
}

/** Τελευταία γραμμή φύλλου με βάση τα metadata του ExcelJS */
function getSheetLastRowIndex(sheet: any): number {
  const fromActual = Number(sheet.actualRowCount) || 0;
  const fromRowCount = Number(sheet.rowCount) || 0;
  const fromRowsArray = sheet._rows?.length > 0 ? sheet._rows.length - 1 : 0;
  return Math.max(fromActual, fromRowCount, fromRowsArray);
}

/**
 * Προ-σάρωση φύλλου: μετράει τις γραμμές προς επεξεργασία με την ίδια
 * λογική τερματισμού (2 συνεχόμενες κενές γραμμές) ώστε το progress bar
 * να βασίζεται στο πραγματικό πλήθος και όχι στο sheet._rows.length.
 */
export function scanImportWorksheetRows(
  sheet: any,
  headerRowIdx: number,
  fieldMapState: ImportFieldMapState,
): ImportRowScanResult {
  let nullRowCount = 0;
  let totalRows = 0;
  let endRowInclusive = headerRowIdx;
  const startRow = headerRowIdx + 1;
  const lastRowIndex = getSheetLastRowIndex(sheet);

  for (let j = startRow; j <= lastRowIndex; j++) {
    if (nullRowCount >= 2) break;

    const row = getWorksheetRowValues(sheet, j);
    totalRows++;
    endRowInclusive = j;

    if (!row) {
      nullRowCount++;
      continue;
    }

    const code = resolveCollectionCode(fieldMapState, row);
    if (code === null) {
      nullRowCount++;
    } else {
      nullRowCount = 0;
    }
  }

  return {
    totalRows: Math.max(totalRows, 1),
    startRow,
    endRowInclusive: Math.max(endRowInclusive, startRow),
  };
}
